export default "__VITE_ASSET__CaByBYjk__"